import React from "react";
import { BackButton, LoginWrapper } from "shared";
import "./TermsOfServicePage.scss";
import { ROUTE_ENUM } from "enums";
import { useGoBackOrHome } from "utils";

type TermsOfServicePageProps = {};

const TermsOfServicePage: React.FC<TermsOfServicePageProps> = () => {
  const goBackOrHome = useGoBackOrHome();

  return (
    <LoginWrapper className="terms-of-service-page">
      <>
        <BackButton onClick={goBackOrHome} />
        <p className="login-wrapper__subtitle">
          <div className="rodo-container">
            <h1 className="login-wrapper__header">Regulamin aplikacji</h1>
            <ol className="numeric indentation--big">
              <li>
                Właścicielem aplikacji Reliance App (zwanej dalej{" "}
                <strong>“Aplikacją”</strong>) jest spółka Reliance Holding Sp. z
                o.o., z siedzibą w Krakowie, adres: al. 29 Listopada 39E/ U3,
                31-425 Kraków, wpisana w Rejestrze Przedsiębiorców prowadzonym
                przez Sąd Rejonowy dla Krakowa - Śródmieścia, XI Wydział
                Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS:
                0000686682, NIP: 6751598679, REGON: 36780485000000, kapitał
                zakładowy: 600 000,00 złotych (zwana dalej{" "}
                <strong>“Usługodawcą”</strong>).
              </li>
              <li>
                Niniejszy Regulamin skierowany jest do wszystkich użytkowników
                oraz określa zasady dokonywania rejestracji i korzystania z
                Aplikacji.
              </li>
              <li>
                Administratorem danych osobowych jest spółka Reliance Holding
                Sp. z o.o., z siedzibą w Krakowie, adres: al. 29 Listopada
                39E/U3, 31-425 Kraków, wpisana w Rejestrze Przedsiębiorców
                prowadzonym przez Sąd Rejonowy dla Krakowa - Śródmieścia, XI
                Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS:
                0000686682, NIP: 6751598679, REGON: 36780485000000, kapitał
                zakładowy: 600 000,00 złotych.
              </li>
            </ol>
            <h2>§ 1 Definicje</h2>
            <div className="definition indentation--big">
              <p>
                <strong>Użytkownik</strong> – osoba fizyczna lub prawna
                posiadająca konto indywidualne w Aplikacji.
              </p>
              <p>
                <strong>Kodeks Cywilny</strong> - ustawa kodeks cywilny z dnia
                23 kwietnia 1964 r. (t.j. Dz.U. z 2024 r., poz. 1061 z późn.
                zm.).
              </p>
              <p>
                <strong>Konsument</strong> – oznacza osobę fizyczną dokonującą z
                przedsiębiorcą czynności prawnej niezwiązanej bezpośrednio z jej
                działalnością gospodarczą lub zawodową.
              </p>
              <p>
                <strong>Konto indywidualne</strong> – panel przypisany
                indywidualnie do Użytkownika po rejestracji danych w Aplikacji,
                pozwalający na korzystanie przez Użytkownika z funkcjonalności
                Aplikacji.
              </p>
              <p>
                <strong>Przedsiębiorca</strong> - oznacza osobę fizyczną, osobę
                prawną lub jednostkę organizacyjną niebędącą osobą prawną,
                której ustawa przyznaje zdolność prawną, prowadzącą we własnym
                imieniu działalność gospodarczą lub zawodową i dokonującą
                czynności prawnej związanej bezpośrednio z jej działalnością
                gospodarczą lub zawodową.
              </p>
              <p>
                <strong>Plik</strong> – dokument w formacie .pdf zamieszczany w
                Aplikacji przez Użytkownika i przechowywany w Aplikacji.
              </p>
              <p>
                <strong>Informacja</strong> rynkowa – wiadomość dotycząca
                spółek, w których Użytkownik posiada udziały lub akcje.
              </p>
              <p>
                <strong>Regulamin</strong> - oznacza niniejszy regulamin.
              </p>
              <p>
                <strong>Usługi</strong> – oznacza funkcjonalności Aplikacji
                oferowane Użytkownikom polegające w szczególności na:
                przechowywaniu i przeglądaniu Plików z umowami dotyczącymi
                zakupu akcji lub udziałów, otrzymywaniu Informacji rynkowych,
                zarządzaniu strukturą folderów dla przechowywanych Plików.
              </p>
              <p>
                <strong>Dane kontaktowe</strong> – następujące dane, za pomocą
                których Użytkownik ma możliwość skontaktowania się z
                Usługodawcą: adres e-mail: biuro@reliance.pro lub poprzez
                kontakt telefoniczny z Biurem Obsługi Klienta od poniedziałku do
                piątku w godzinach 8:00-16:00, pod numerem telefonu: +48 12 345
                07 44.
              </p>
              <p>
                <strong>Umowa</strong> – umowa o świadczenie Usług zawarta
                między Użytkownikiem a Usługodawcą.
              </p>
            </div>
            <h2>§ 2 Postanowienia ogólne i zasady korzystania z Aplikacji</h2>
            <ol className="numeric indentation--big">
              <li>
                Zdjęcia i opisy oferowanych produktów służą prezentacji
                konkretnie wskazanych na nich modeli Towarów.
              </li>
              <li>
                Minimalne wymagania techniczne, których spełnienie jest
                niezbędne do korzystania z Aplikacji to: (1) komputer, laptop
                lub inne urządzenie multimedialne z dostępem do Internetu; (2)
                dostęp do poczty elektronicznej i ważny adres e-mail; (3)
                standardowa przeglądarka internetowa.
              </li>
              <li>Nie jest dopuszczalne:</li>
              <ul>
                <li>
                  korzystanie z Aplikacji w celu prowadzenia działalności, która
                  naruszałaby interes Usługodawcy, w sposób sprzeczny z prawem,
                  dobrymi obyczajami lub naruszający dobra osobiste osób
                  trzecich,
                </li>
                <li>dostarczanie do Aplikacj itreści bezprawnych,</li>
                <li>
                  korzystanie z Aplikacji w sposób zakłócający jej
                  funkcjonowanie lub podejmowanie czynności informatycznych lub
                  wszelkich innych czynności mających na celu wejście w
                  posiadanie informacji nieprzeznaczonych dla Użytkownika, w tym
                  danych innych Użytkowników,
                </li>
                <li>
                  umieszczanie w ramach Aplikacji niezamówionej informacji
                  handlowej,oraz
                </li>
                <li>
                  korzystanie z treści umieszczonych w Aplikacji do innego
                  użytku niż użytek własny.
                </li>
              </ul>
              <li>
                Użytkownik jest odpowiedzialny za treść Plików zamieszczanych w
                Aplikacji oraz zgodność danych z obowiązującym prawem.
              </li>
              <li>
                Usługodawca zastrzega sobie prawo do zablokowania Konta
                indywidualnego Użytkownika w przypadku naruszenia Regulaminu lub
                przepisów powszechnie obowiązującego prawa.
              </li>
              <li>
                Administrator ma prawo do usunięcia treści lub zablokowania
                konta w przypadku naruszenia regulaminu.
              </li>
              <li>
                Użytkownik powinien zachować w poufności swoje dane dostępowe do
                Aplikacji w taki sposób, aby uniemożliwić dostęp do nich osobom
                nieuprawnionym.
              </li>
              <li>
                Dostęp do niektórych Usług w ramach Aplikacji może być
                ograniczony w zależności od pakietu wybranego przez Użytkownika.
              </li>
            </ol>
            <h2>§ 3 Rejestracja Konta indywidualnego i logowanie</h2>
            <ol className="numeric indentation--big">
              <li>
                W celu utworzenia Konta indywidualnego, Użytkownik obowiązany
                jest dokonać rejestracji swoich danych w Aplikacji. Rejestracja
                danych odbywa się poprzez wypełnienie formularza rejestracyjnego
                wraz z wybraniem opcji „Zarejestruj się”. Wypełnienie formularza
                wymaga podania imienia i nazwiska, oraz numeru telefonu.
              </li>
              <li>
                Warunkiem utworzenia Konta indywidualnego jest akceptacja
                Regulaminu oraz Polityki Prywatności poprzez oznaczenie
                odpowiedniego pola w formularzu.
              </li>
              <li>
                Po przesłaniu wypełnionego formularza rejestracyjnego Użytkownik
                otrzymuje niezwłocznie, drogą elektroniczną na adres poczty
                elektronicznej podany w formularzu rejestracyjnym potwierdzenie
                rejestracji Konta indywidualnego w Aplikacji. Z tą chwilą
                zawarta zostaje Umowa o świadczenie drogą elektroniczną usługi
                Konta indywidualnego, zaś Użytkownik uzyskuje możliwość dostępu
                do Konta indywidualnego i dokonywania zmian swoich danych
                podanych w momencie rejestracji.
              </li>
              <li>
                W celu zalogowania się do Konta indywidualnego w Aplikacji,
                Użytkownik podaje numer telefonu wskazany przy rejestracji Konta
                indywidualnego, a następnie wpisuje 4-cyfrowy kod wysłany SMS-em
                na podany przez Użytkownika numer telefonu.
              </li>
              <li>
                Użytkownik w każdym momencie może złożyć Usługodawcy żądanie
                zaprzestania świadczenia Usługi Konta indywidualnego. W takim
                wypadku Umowa o świadczenie odpowiednio usługi Konta
                indywidualnego rozwiązuje się, a Usługodawca ma 14 dni na
                usunięcie Konta indywidualnego, z zastrzeżeniem zasad
                przetwarzania danych osobowych Klientów zawartych w dokumencie
                „Polityka Prywatności”.
              </li>
            </ol>
            <h2>§ 4 Zakup pakietu i płatności</h2>
            <ol className="numeric indentation--big">
              <li>
                W celu korzystania z Usług dostępnych w Aplikacji, Użytkownik
                wybiera odpowiedni pakiet. Pakiety różnią się zakresem Usług
                oraz ceną.
              </li>
              <li>
                Płatność za Usługi jest wykonywana przy pomocy karty płatniczej,
                której dane Użytkownik podaje podczas zakupu pakietu.
              </li>
              <li>
                Umowa będzie automatycznie odnawiana na koniec każdego miesiąca
                na kolejne miesięczne okresy pod warunkiem, że żadna ze stron
                nie wypowie Umowy.
              </li>
              <li>
                Płatność za Usługi dokonywana jest automatycznie 10. dnia
                każdego miesiąca.
              </li>
              <li>
                Użytkownik wyraża zgodę na cykliczne obciążanie karty poprzez
                kliknięcie odpowiedniego pola przy zakupie pakietu. Wyrażając
                zgodę na cykliczne obciążanie karty płatniczej, Użytkownik
                upoważnia Usługodawcę do przechowywania danych swojej karty
                płatniczej.
              </li>
              <li>
                Umowa może zostać rozwiązana w wyniku rezygnacji przez
                Użytkownika w każdym czasie. Umowa rozwiązuje się z chwilą
                otrzymania przez Usługodawcę jednoznacznego oświadczenia
                Użytkownika o rezygnacji.
              </li>
              <li>
                W przypadku rezygnacji z Usług przez Użytkownika po pobraniu
                płatności za ten miesiąc, opłata ta nie będzie podlegała
                zwrotowi.
              </li>
              <li>
                Użytkownik otrzyma dostęp do funkcjonalności oferowanych w
                ramach wybranego pakietu z chwilą otrzymania przez Usługodawcę
                płatności w wysokości właściwej dla danego pakietu. Jeżeli
                Usługodawcy nie uda się pobrać płatności z powodu odrzucenia lub
                odmowy realizacji transakcji Usługodawca poinformuje
                Użytkownika, że próba pobrania płatności zakończyła się
                niepowodzeniem. W ciągu następnych 3 dni Usługodawca spróbuje
                ponownie pobrać płatność. Jeżeli próba ta nie powiedzie się,
                Umowę uważa się za rozwiązaną.
              </li>
            </ol>
            <h2>§ 5 Reklamacje</h2>
            <ol className="numeric indentation--big">
              <li>
                Usługodawca podejmuje działania w celu zapewnienia w pełni
                poprawnego funkcjonowania Usług, w tym Aplikacji za pomocą
                której są one dostępne, w takim zakresie, jaki wynika z
                aktualnej wiedzy technicznej i zobowiązuje się usunąć w
                rozsądnym terminie wszelkie nieprawidłowości zgłoszone przez
                Użytkowników.
              </li>
              <li>
                Użytkownicy mogą składać reklamację poprzez wysłanie wiadomości
                e-mail na adres:{" "}
                <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>
                wraz z opisem powstałego problemu.
              </li>
              <li>
                Wskazane jest, aby zgłoszenie reklamacji zawierało w
                szczególności: imię, nazwisko, adres e-mail, na który ma zostać
                wysłana odpowiedź na reklamację, a także dokładny opis problemu.
              </li>
              <li>
                Użytkownik otrzyma informację o sposobie rozpatrzenia reklamacji
                niezwłocznie, nie później niż w terminie 14 dni od dnia
                zgłoszenia żądania przez Użytkownika na adres e-mail
                Usługodawcy.
              </li>
            </ol>
            <h2>§ 6 Konsumenckie prawo odstąpienia od Umowy</h2>
            <ol className="numeric indentation--big">
              <li>
                Konsumenckie prawo odstąpienia od umowy zawartej poza lokalem
                przedsiębiorstwa lub na odległość, o którym mowa w art. 27
                ustawy o konsumentach nie przysługuje Konsumentowi w odniesieniu
                do umów o dostarczanie treści cyfrowych niedostarczanych na
                nośniku materialnym, za które konsument jest zobowiązany do
                zapłaty ceny, jeżeli przedsiębiorca rozpoczął świadczenie za
                wyraźną i uprzednią zgodą konsumenta, który został poinformowany
                przed rozpoczęciem świadczenia, że po spełnieniu świadczenia
                przez przedsiębiorcę utraci prawo odstąpienia od umowy, i
                przyjął to do wiadomości, a przedsiębiorca przekazał
                konsumentowi potwierdzenie, o którym mowa w art. 15 ust. 1 i 2
                albo art. 21 ust. 1 ustawy o prawach konsumenta.
              </li>
            </ol>
            <h2>§ 7 Prawa autorskie</h2>
            <ol className="numeric indentation--big">
              <li>
                Usługodawca zastrzega sobie wyłączność przysługujących mu praw
                własności intelektualnej związanych z Usługami oraz Aplikacją, a
                w tym szaty graficznej, grafik, obrazów, utworów literackich,
                kodów źródłowych, plików multimedialnych, projektów, animacji,
                interfejsów, dokumentacji, ich kolejnych wersji, metod,
                produktów, algorytmów, danych, funkcjonalności i elementów
                interaktywnych, narzędzi i metod reklamowych, wynalazków,
                tajemnic przedsiębiorstwa, logotypów, domen, znaków towarowych,
                nazw handlowych i innych oznaczeń identyfikujących, niezależnie
                od tego czy są one zarejestrowane, oraz wszelkich innych
                materiałów stanowiących kub mogących stanowić przedmiot praw
                własności intelektualnej.
              </li>
              <li>Użytkownikowi zabrania się:</li>
              <ul>
                <li>
                  korzystanie z Aplikacji w celu prowadzenia działalności, która
                  naruszałaby interes Usługodawcy, w sposób sprzeczny z prawem,
                  dobrymi obyczajami lub naruszający dobra osobiste osób
                  trzecich,
                </li>
                <li>dostarczanie do Aplikacji treści bezprawnych,</li>
                <li>
                  korzystanie z Aplikacji w sposób zakłócający jej
                  funkcjonowanie lub podejmowanie czynności informatycznych lub
                  wszelkich innych czynności mających na celu wejście w
                  posiadanie informacji nieprzeznaczonych dla Użytkownika, w tym
                  danych innych Użytkowników,
                </li>
                <li>
                  umieszczanie w ramach Aplikacji niezamówionej informacji
                  handlowej,oraz
                </li>
                <li>
                  korzystanie z treści umieszczonych w Aplikacji do innego
                  użytku niż użytek własny.
                </li>
              </ul>
              <li>
                Usługodawca ma prawo kontroli sposobu korzystania z Aplikacji
                przez Użytkownika pod kątem jego zgodności z postanowieniami
                Regulaminu i przepisami powszechnie obowiązującego prawa.
              </li>
            </ol>
            <h2>§ 8 Odpowiedzialność</h2>
            <ol className="numeric indentation--big">
              <li>
                Usługodawca nie odpowiada za naruszenia powstałe w wyniku
                działań Użytkowników sprzecznych z niniejszym Regulaminem oraz
                za naruszenia dokonane przez osoby trzecie wynikające pośrednio
                lub bezpośrednio z działania Użytkownika lub działania osób
                trzecich, na które Usługodawca nie miał wpływu i nie był w
                stanie zapobiec zachowując poziom rzetelności w świadczeniu
                Usług zgodnie z Regulaminem i przepisami powszechnie
                obowiązującego prawa.
              </li>
              <li>
                <strong>
                  Usługodawca nie ponosi odpowiedzialności za decyzje
                  inwestycyjne podjęte na podstawie Informacji rynkowych
                  udostępnianych w Aplikacji.
                </strong>
              </li>
              <li>
                Użytkownik przyjmuje do wiadomości, iż podejmowane przez niego
                decyzje inwestycyjne powinny być każdorazowo przeanalizowane w
                ramach konkretnego stanu faktycznego, który w zależności od
                okoliczności, podmiotu, który decyzje podejmuje, założonych
                celów oraz posiadanych środków będzie uzasadniał zastosowanie
                odpowiednich działań. Obowiązkiem Użytkownika jest niezależne
                określenie czy wykorzystać jakiekolwiek informacje dostarczane
                za pośrednictwem Aplikacji. Korzystanie z informacji
                dostarczonych za pośrednictwem Aplikacji odbywa się wyłącznie na
                własne ryzyko Użytkownika.
              </li>
              <li>
                W najszerszym zakresie dopuszczalnym przepisami prawa
                Usługodawca nie ponosi odpowiedzialności za jakiekolwiek szkody,
                w tym za szkody w wyniku utraty zysków, utraty danych, przerwy w
                działalności lub inne szkody i straty biznesowe powstałe w
                wyniku lub w związku z korzystaniem lub niemożliwością
                korzystania z Aplikacji, niezależnie od ich przyczyny. Przepisy
                szczególne (np. przepisy dotyczące praw konsumentów) mogą nie
                zezwalać na wyłączenie odpowiedzialności Usługodawcy w zakresie
                wskazanym w zdaniu poprzedzającym, więc powyższe ograniczenie
                może nie dotyczyć wszystkich Użytkowników.
              </li>
              <li>
                Usługodawca nie ponosi także odpowiedzialności za niewykonanie
                lub nieprawidłowe wykonanie Umowy będące wynikiem tzw. siły
                wyższej, a w szczególności wojny, działań wojennych, blokad,
                działań państw uniemożliwiających wykonanie zobowiązania przez
                Usługodawcę, pożarów, powodzi, innych klęsk żywiołowych, czy
                epidemii przez cały czas trwania powyższych okoliczności.
              </li>
              <li>
                Usługodawca nie ponosi odpowiedzialności za ewentualne szkody
                powstałe w wyniku zamieszczenia w Aplikacji przez Użytkownika
                informacji błędnych lub niezgodnych z prawdą.
              </li>
              <li>
                Usługodawca nie ponosi odpowiedzialności za wady funkcjonowania
                Aplikacji i Usług wynikające z winy lub niedbalstwa Użytkownika.
                W szczególności Usługodawca nie ponosi odpowiedzialności za
                nieprawidłowe działanie Aplikacji i Usług wynikające ze stanu
                technicznego systemu informatycznego Użytkownika, a także błędy
                w transmisji danych (łącze internetowe).
              </li>
            </ol>
            <h2>§ 9 Ochrona danych</h2>
            <ol className="numeric indentation--big">
              <li>
                Dane osobowe Klienta są przetwarzane przez spółkę Reliance
                Holding Sp. z o.o., z siedzibą w Krakowie, adres: al. 29
                Listopada 39E/U3, 31-425 Kraków, wpisana w Rejestrze
                Przedsiębiorców prowadzonym przez Sąd Rejonowy dla Krakowa -
                Śródmieścia, XI Wydział Gospodarczy Krajowego Rejestru Sądowego
                pod numerem KRS: 0000686682, NIP: 6751598679, REGON:
                36780485000000, kapitał zakładowy: 600 000,00 złotych jako
                administratora danych osobowych.
              </li>
              <li>
                Usługodawca stosuje odpowiednie środki techniczne i
                organizacyjne zapewniające ochronę danych osobowych, a także
                wszelkich Plików zamieszczanych i przechowywanych w Aplikacji
                przed nieuprawnionym dostępem .
              </li>
              <li>
                W przypadku podejrzenia naruszenia ochrony danych Użytkownik
                powinien niezwłocznie powiadomić Usługodawcę.
              </li>
              <li>
                Zasady i cele przetwarzania danych osobowych Klientów zawarte są
                w dokumencie{" "}
                <a href={ROUTE_ENUM.PRIVACY_POLICY}>„Polityka Prywatności”</a>,
                dostępnej na stronie internetowej Sklepu pod zakładką{" "}
                <a href={ROUTE_ENUM.PRIVACY_POLICY}>„Polityka Prywatności”</a>.
              </li>
            </ol>
            <h2>§ 10 Postanowienia końcowe</h2>
            <ol className="numeric indentation--big">
              {/* TODO DATA */}
              <li>Regulamin obowiązuje od dnia 01.09.2025 r.</li>
              <li>
                Użytkownik będący Konsumentem ma prawo korzystania z
                pozasądowych sposobów rozpatrywania reklamacji i dochodzenia.
                Szczegółowe informacje dotyczące możliwości skorzystania przez
                Użytkowników będących Konsumentami z takich sposobów
                rozpatrywania reklamacji i dochodzenia roszczeń, jak również
                zasady dostępu do tych procedur znajdują się na stronie
                internetowej Urzędu Ochrony Konkurencji i Konsumentów
                (www.uokik.gov.pl). Informacje na ten temat mogą być również
                dostępne w siedzibach oraz na stronach internetowych
                Wojewódzkich Inspektoratów Inspekcji Handlowej, powiatowych
                (miejskich) rzeczników konsumentów, jak również organizacji
                społecznych, do których zadań statutowych należy ochrona
                konsumentów. Klientowi będącemu Konsumentem lub Przedsiębiorcą z
                uprawnieniami Konsumenta przysługuje możliwość skorzystania z
                następujących, pozasądowych sposobów dochodzenia roszczeń oraz
                rozpatrywania reklamacji:
              </li>
              <ul>
                <li>
                  możliwość zwrócenia się z wnioskiem o przeprowadzenie
                  postępowania w sprawie pozasądowego rozwiązywania sporów
                  konsumenckich na podstawie Ustawy z dnia 23 września 2016 r. o
                  pozasądowym rozwiązywaniu sporów konsumenckich (Dz. U. z 2016
                  r., poz. 1823), tj. np. do Wojewódzkiego Inspektora Inspekcji
                  Handlowej w Katowicach;
                </li>
                <li>
                  wystąpienie z wnioskiem o rozpoznanie sprawy przez Stały
                  Polubowny Sąd 6 Konsumencki działający przy odpowiednim
                  Wojewódzkim Inspektoracie Inspekcji Handlowej oraz
                </li>
                <li>
                  zwrócenie się do Miejskiego Rzecznika Praw Konsumentów o pomoc
                  w zakresie ochrony interesów i praw konsumentów.
                </li>
              </ul>
              <li>
                Brak akceptacji Regulaminu uniemożliwia korzystanie z Aplikacji.
                Usługodawca umożliwi Użytkownikowi zapoznanie się z Regulaminem
                przy rejestracji Konta indywidualnego. Użytkownicy posiadający
                Konto indywidualne zostaną poinformowani o zmianie Regulaminu za
                pośrednictwem korespondencji e-mail. Klientowi, który nie
                akceptuje wprowadzonych w Regulaminie zmian przysługuje prawo
                odstąpienia od Umowy świadczenia usług drogą elektroniczną.
              </li>
              <li>
                Wszelkie spory lub roszczenia wynikające z Umów zawartych na
                podstawie niniejszego Regulaminu będą rozstrzygane przez sąd
                właściwy ze względu na siedzibę Usługodawcy.
              </li>
              <li>
                Prawem właściwym dla niniejszego Regulaminu jest prawo polskie.
              </li>
              <li>
                Prawem właściwym dla rozstrzygania wszelkich sporów powstałych
                na gruncie niniejszego Regulaminu jest prawo polskie. W sprawach
                nieuregulowanych w niniejszym Regulaminie mają zastosowanie
                powszechnie obowiązujące przepisy prawa polskiego, w
                szczególności: Kodeksu Cywilnego oraz inne właściwe przepisy
                powszechnie obowiązującego prawa.
              </li>
            </ol>
          </div>
        </p>
      </>
    </LoginWrapper>
  );
};

export default TermsOfServicePage;
